import { createFeature, createReducer } from '@ngrx/store';

import { newOpportunitySimilarJobsReducers } from './new-opportunity-similar-jobs.reducer';
import { newOpportunitySimilarJobsInitialState } from './new-opportunity-similar-jobs.state';

export const newOpportunitySimilarJobsFeature = createFeature({
    name: 'newOpportunitySimilarJobs',
    reducer: createReducer(newOpportunitySimilarJobsInitialState, ...newOpportunitySimilarJobsReducers),
});
